export default "__VITE_ASSET__560c874b__"